import { useEffect, useRef, useCallback } from 'react';

// 30 secondes en millisecondes (définie via .env)
const timeoutMinutes = process.env.REACT_APP_INACTIVITY_TIMEOUT_MINUTES || 30;
const INACTIVITY_TIMEOUT = timeoutMinutes * 1000;

/**
 * Hook pour monitorer l'inactivité de l'utilisateur.
 * @param {Function} onTimeout - Callback à exécuter lorsque le délai est dépassé.
 */
const useInactivityMonitor = (onTimeout) => {
    const timeoutRef = useRef(null);
    const onTimeoutRef = useRef(onTimeout);

    // Met à jour la référence du callback si le parent change 
    useEffect(() => {
        onTimeoutRef.current = onTimeout;
    }, [onTimeout]);

    const resetTimer = useCallback(() => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = setTimeout(() => {
            // Exécute le callback passé en paramètre
            onTimeoutRef.current && onTimeoutRef.current();
        }, INACTIVITY_TIMEOUT);
    }, []);

    const handleActivity = useCallback(() => {
        resetTimer();
    }, [resetTimer]);

    useEffect(() => {
        resetTimer();
        window.addEventListener('mousemove', handleActivity);
        window.addEventListener('keydown', handleActivity);
        window.addEventListener('click', handleActivity);

        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
            window.removeEventListener('mousemove', handleActivity);
            window.removeEventListener('keydown', handleActivity);
            window.removeEventListener('click', handleActivity);
        };
    }, [handleActivity, resetTimer]);
};

export default useInactivityMonitor;